module.exports = __webpack_public_path__ + "static/media/invoicingar_cc_pay_guide_1.44d6c56b.png";